module.exports = __webpack_public_path__ + "static/media/scale-with-you.d694d981.svg";